import type { Form } from '../../../../common/types/form';
import type { Documentation } from '../../../../common/types/documentation';

import dateHoursParticipantsFields from '../../../form/dateHoursParticipantsFields';
import dateHoursFields from '../../../form/dateHoursFields';

const meetingExternForm: Form<Documentation> = {
  key: 'meetingExtern',
  title: 'Vernetzungstreffen',
  fields: [
    ...dateHoursFields,
    {
      key: 'topic',
      label: 'Thema',
      fieldTypes: 'text',
    },
  ],
};

export default meetingExternForm;
